import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportServiceView,
    GetDataFilterValuesParameters,
    GetProjectModuleSubcontractorColumnChartValuesResultType,
    GetProjectModuleSubcontractorLineChartValuesResultType,
    GetProjectModuleSubcontractorMetricsValuesResultType,
    GetProjectModuleSubcontractorValuesResultType,
    ReportResultColumnDto,
    ServiceSubcontractorClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ServiceSubcontractorService extends CustomReportServiceBase<
    ServiceSubcontractorClient,
    CustomReportServiceView
> {
    constructor(protected override client: ServiceSubcontractorClient) {
        super(client);
    }

    async getValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorValuesResultType[]> {
        return await lastValueFrom(this.client.serviceSubcontractorGetServiceModuleSubcontractorValues(parameters));
    }

    async getBoxesValues(parameters: GetDataFilterValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(
            this.client.serviceSubcontractorGetServiceModuleSubcontractorBoxesValues(parameters)
        );
    }

    async getColumnChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorColumnChartValuesResultType[]> {
        return await lastValueFrom(
            this.client.serviceSubcontractorGetServiceModuleSubcontractorColumnChartValues(parameters)
        );
    }

    async getMetricsValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorMetricsValuesResultType> {
        return await lastValueFrom(
            this.client.serviceSubcontractorGetServiceModuleSubcontractorMetricsValues(parameters)
        );
    }

    async getLineChartValues(
        parameters: GetDataFilterValuesParameters
    ): Promise<GetProjectModuleSubcontractorLineChartValuesResultType[]> {
        return await lastValueFrom(
            this.client.serviceSubcontractorGetServiceModuleSubcontractorLineChartValues(parameters)
        );
    }

    override async saveCustomReport(body: CustomReportServiceView): Promise<CustomReportServiceView> {
        if (body.isPublic) return await lastValueFrom(this.client.serviceSubcontractorSaveCatalogReport(body));
        else return await lastValueFrom(this.client.serviceSubcontractorSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceSubcontractorGetCustomReport(id));
    }

    override async shareReport(body: CustomReportServiceView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.serviceSubcontractorCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportServiceView> {
        return await lastValueFrom(this.client.serviceSubcontractorGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.serviceSubcontractorResultAvailableColumns(organizationIds));
    }
}
